import React from "react";
import { NavLink } from "react-router-dom";
import AllPlayer from "./AllPlayer";
import BannerCarousel from "./BannerCarousel";
import Countdown from "./Countdown";
import About from "../pages/about/About";

const Registration = () => {
  return (<>
      <Countdown />      
      <About />
  </>
  );
};

export default Registration;
